module.exports = __webpack_public_path__ + "static/img/iEP-6.defde7e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/iEP-6.jpg
// module id = EUQ8
// module chunks = 1